import { createRequestHandler } from "../../lib/request";

const getNodeApiUrl = () => {
    const url = new URL(window.location.origin);

    if (url.port === "30010" || url.port === "3000") {
        url.port = "3100";
    }

    return `${url.origin}/nodeapi`;
}

export const CLIENT_CONFIG = {
    API_URL: (window.location.origin.replace(":3000", "")) + "/api",
    NODE_API_URL: getNodeApiUrl(),
    // API_URL: "https://eq.truto.ru/api",
    ROUTE_HEAD: "/queue",
}

export const queueRequest = createRequestHandler(CLIENT_CONFIG.API_URL);
export const nodeQueueRequest = createRequestHandler(CLIENT_CONFIG.NODE_API_URL);
